import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { installDevHandle } from './dev/handle';

const container = document.getElementById('root');
if (!container) throw new Error('The #root element was not found');

if (import.meta.env.DEV) installDevHandle();

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
